<template>
  <div class="relative flex size-full flex-col bg-white">
    <div
      id="chat-modal-root"
      class="pointer-events-none absolute inset-0 z-50"
    ></div>
    <div class="flex-1 overflow-y-auto">
      <Home v-if="chatStore.tab === 'home'" @close="handleClose" />
      <Dialog
        v-if="chatStore.tab === 'dialog'"
        :dialog-id="chatStore.dialogId"
        @close="handleClose"
        @update-title="handleUpdateTitle"
      />
      <NewDialog
        v-if="chatStore.tab === 'newDialog'"
        @close="handleClose"
        @populateNewMessage="populateNewMessage"
      />
      <DialogsHistory
        v-if="chatStore.tab === 'history'"
        class="h-full"
        @dialog-selected="onDialogSelected"
        @close="handleClose"
      />
      <ProactiveSuggestionsThread
        v-if="chatStore.tab === 'proactiveSuggestions'"
        @close="handleClose"
      />
      <ProactiveGeofenceRemovalsThread
        v-if="chatStore.tab === 'proactiveGeofenceRemovals'"
        @close="handleClose"
      />
    </div>

    <div
      v-if="
        chatStore.tab === 'dialog' ||
        chatStore.tab === 'home' ||
        chatStore.tab === 'newDialog'
      "
      class="flex flex-col border-t border-gpx_gray-900 p-2"
    >
      <NewMessage
        :dialog-id="chatStore.dialogId"
        :message="chatStore.chatMessage"
      />
    </div>
    <div class="flex flex-col border-t border-gpx_gray-900 p-2">
      <Tabs v-model="tab" />
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import NewMessage from './NewMessage.vue';
import DialogsHistory from '@/components/ai/DialogsHistory.vue';
import Home from '@/components/ai/Home.vue';
import NewDialog from '@/components/ai/NewDialog.vue';
import Dialog from '@/components/ai/Dialog.vue';
import ProactiveSuggestionsThread from '@/components/place-suggestions/ProactiveSuggestionsThread.vue';
import ProactiveGeofenceRemovalsThread from '@/components/geofence-removals/ProactiveGeofenceRemovalsThread.vue';
import Tabs from '@/components/ai/Tabs.vue';
import { useChatStore } from '@/stores/useChatStore';
import * as event from '@/events';

const emit = defineEmits(['close', 'update-title']);
const chatStore = useChatStore();

const tab = computed({
  get: () => chatStore.tab,
  set: (value) => {
    if (value === 'history') {
      event.trigger(event.names.SCOUT_HISTORY_OPENED);
    }
    chatStore.setTab(value);
  },
});

const handleClose = () => {
  event.trigger(event.names.SCOUT_TOGGLED);
  emit('close');
};

const handleUpdateTitle = (payload) => {
  emit('update-title', payload);
};

const populateNewMessage = (msg) => {
  if (!chatStore.dialogId) {
    chatStore.setChatMessage(msg);
  }
};

const onDialogSelected = (id) => {
  event.trigger(event.names.SCOUT_CHAT_OPENED_FROM_HISTORY);
  chatStore.onDialogSelected(id);
};
</script>
